import { render, staticRenderFns } from "./ChangeViaSms.vue?vue&type=template&id=13a93406&"
import script from "./ChangeViaSms.vue?vue&type=script&lang=js&"
export * from "./ChangeViaSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports